
  // menú desplegable (Caballero / Dama / Unisex)
  var hamb=document.getElementById('hambBtn'), dd=document.getElementById('dropdown');
  hamb.addEventListener('click',function(e){e.stopPropagation();
    var open=dd.classList.toggle('open');hamb.setAttribute('aria-expanded',open);});
  document.addEventListener('click',function(e){
    if(!dd.contains(e.target)&&!hamb.contains(e.target)){dd.classList.remove('open');hamb.setAttribute('aria-expanded','false');}});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){dd.classList.remove('open');hamb.setAttribute('aria-expanded','false');}});
  dd.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){dd.classList.remove('open');hamb.setAttribute('aria-expanded','false');});});

  // Los botones "Agregar al carrito" los maneja VelantisCart (ver final del documento).

  // promo after 2 minutes (once per session)
  var overlay=document.getElementById('overlay');
  function openPromo(){overlay.classList.add('show');}
  function closePromo(){overlay.classList.remove('show');}
  document.getElementById('promoClose').addEventListener('click',closePromo);
  overlay.addEventListener('click',function(e){if(e.target===overlay)closePromo();});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closePromo();});
  if(!sessionStorage.getItem('velantisPromo')){
    setTimeout(function(){openPromo();sessionStorage.setItem('velantisPromo','1');},120000); // 2 min
  }
